import React from 'react'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
function WellTippedBadge() {
  return (
    <>
      <WorkspacePremiumIcon className='featuredArtistsBadgeIcon featuredArtistsBadgeWorkspace'/>
    </>
  )
}

export default WellTippedBadge